var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"boxList":_vm.boxList}}),_c('router-view',{staticStyle:{"margin-top":"1rem"}}),_c('Footer'),(_vm.classNames)?_c('div',{staticClass:"maskLayer",on:{"click":_vm.hideBox}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }